import React from "react";
import { connect } from "react-redux";
import { View, Text, Image, TextInput, Dimensions, TouchableOpacity } from "react-native";
import { withTranslation } from "react-i18next";
import { RadioGroup, RadioButton } from "react-native-flexi-radio-button";
import { StyleSheet } from "react-native";
import Modal from "react-native-modal";
import { Container, Content, Left, Body, Right, Button, Title } from "native-base";
import _ from "lodash";

import Header from "../../components/ui/WrappedHeader";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import ScreenLoadingIndicator from "../../components/ui/ScreenLoadingIndicator";
import { NavigationService } from "../../navigation";
import UIDs from "../../UIDs";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../redux/screens/me/WithdrawRedux";
import Icon from "react-native-vector-icons/Ionicons";
import EntypoIcon from "react-native-vector-icons/Entypo";
import { AppStyles } from "../../theme/index";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";

const uid = UIDs.screens.me.withdraw;

let t = null;
class WithdrawScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null },
            [ActionTypes.SEND_VERIFY_CODE_ASYNC]: { done: this._handleSendVerifyCodeAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.VERIFY_CODE_ASYNC]: { done: this._handlVerifyCodeAsyncDone, error: this._handleVerifyCodeAsyncActionError },
            [ActionTypes.SAVE_WITHDRAWAL_ASYNC]: { done: this._handlSaveWithdrawalAsyncDone, error: this._handleAsyncActionError },
        };
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();

        // call load screen view to update analytics
        this.props.loadScreenViewAsync();
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        if (t) clearTimeout(t);
    }

    renderScreen() {
        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) {
            return <ScreenLoadingIndicator title={this.props.t("withdraw")} />;
        }

        const { availableBalance, baseCurrency, bankAccounts, bankAccountId, amountApplied, isOpen } = this.props.localState;
        const symbol = baseCurrency ? baseCurrency.symbol : "";
        return (<View style={this.props.style || {flex: 1}}>
                <Container>
                    <Header style={[styles.headerColor]}>
                        <Left style={[styles.flex1]}>
                            <Button transparent onPress={this._onPressBack}>
                                <Icon name="ios-arrow-back" style={{fontSize: 30, color: "#777"}} />
                            </Button>
                        </Left>
                        <Body style={[styles.flex3, styles.alignItemsCenter]}>
                            <Title style={[styles.headerTitle]}>{this.props.t("withdraw")}</Title>
                        </Body>
                        <Right style={[styles.flex1]} />
                    </Header>
                    <Content style={[styles.backgroundColor]}>
                        <View style={{backgroundColor: "#fff", paddingLeft: 10, paddingVertical: 10}}>
                            <Text style={{color: "#333", fontSize: 12, fontWeight: "300"}}>{this.props.t("title1")}
                            <Text style={{color: "#ffab06", fontSize: 10, fontWeight: "300"}}>{this.props.t("title2")}</Text></Text>
                            <View style={{borderBottomWidth: 1, borderBottomColor: "#f7f7f7", flexDirection: "row", alignItems: "center", marginTop: 10, marginRight: 10}}>
                                <Text style={{color: "#333", fontSize: 20, fontWeight: "800"}}>{symbol}</Text>
                                <TextInput
                                    style={{flex: 1, paddingHorizontal: 5, fontSize: 20}}
                                    onChangeText={this._handleChangeAmount}
                                    onBlur={this._handleChangeAmountEnd}
                                    onSubmitEditing={this._handleChangeAmountEnd}
                                    value = {_.toString(amountApplied)}
                                    keyboardType="numeric"
                                />
                                <Button disabled={availableBalance <= 0} style={{backgroundColor: (availableBalance <= 0 ? "#808080" : "#40BA30"), borderRadius: 4, paddingHorizontal: 15, height: 25}} onPress={() => {
                                    this.props.setState({ amountApplied: availableBalance });
                                }}>
                                    <Text style={{color: "#fff", fontSize: 10, fontWeight: "300"}} ellipsizeMode="tail" numberOfLines={1}>
                                        {this.props.t("allWithdraw")}
                                    </Text>
                                </Button>
                            </View>
                            <Text style={{color: "#b3b3b3", fontSize: 11, fontWeight: "300", marginTop: 10}}>{this.props.t("note", { symbol, balance: availableBalance })}</Text>
                        </View>
                        <View style={{padding: 10, flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                            <Text style={{color: "#a5a5a5", fontSize: 11, fontWeight: "300"}}>{this.props.t("selectBankAccount")}</Text>
                            <TouchableOpacity onPress={() => {
                                NavigationService.navigateToPage(this, UIDs.screens.me.bankAccounts);
                            }}>
                                <View style={{flexDirection: "row", alignItems: "center"}}>
                                    <Text style={{color: "#a5a5a5", fontSize: 11, fontWeight: "300", marginRight: 5}}>{this.props.t("bankAccountManagement")}</Text>
                                    <Icon name="ios-arrow-forward" style={[styles.backIcon, {  paddingLeft: 3}]} />
                                </View>
                            </TouchableOpacity>
                        </View>
                        <RadioGroup
                            size={15}
                            color={"#f96269"}
                            highlightColor={"#fff"}
                            onSelect={(index, id) => this.props.setState({ bankAccountId: id })}
                            selectedIndex={bankAccounts.findIndex(item => item.id === bankAccountId)}
                            style={{ width:"100%", overflow: "hidden"}}
                        >
                            {bankAccounts && bankAccounts.map(({ id, data: { description } }, i) => (
                                <RadioButton key={i} value={id} style={{padding: 10, backgroundColor: "#fff", borderBottomWidth: 1, borderBottomColor: "#f7f7f7", width:"100%", overflow: "hidden", }}>
                                    <View style={{marginTop: -1, minWidth: "min(900px, 95vw)", justifyContent: "center", alignItems: "center"}}>
                                        <Text numberOfLines={2} ellipsizeMode='tail' style={{color: "#333", fontSize: 13, fontWeight: "300", width: "100%",}}>{description}</Text>
                                    </View>
                                </RadioButton>)
                            )}
                        </RadioGroup>
                        <Button full disabled={!(amountApplied > 0)} style={{marginTop: 30, marginHorizontal: 10, backgroundColor: (!(amountApplied > 0) ? "#808080" : "#f96269"), borderRadius: 30}}
                            onPress={this._handleImmediateWithDrawal}>
                            <Text style={{fontSize: 13, color: "#fff", fontWeight: "bold"}}>{this.props.t("immediateWithdrawal")}</Text>
                        </Button>
                        <Modal isVisible={isOpen} backdropOpacity={0.4}
                            avoidKeyboard={true}
                            style={{alignItems: "center", justifyContent: "center", zIndex: 100}}
                            onBackButtonPress={() => {}}
                            onBackdropPress={() => {}}>
                            {this.renderModal()}
                        </Modal>
                    </Content>
                </Container>
                </View>
        );
    }

    renderModal() {
        const { showCodeFailureMsg, countDownStarted, countDown, verificationCode } = this.props.localState;
        const screenWidth = Dimensions.get("window").width;
        return (<View style={{width: screenWidth * 0.9, paddingLeft: 20, paddingRight: 20,
                                paddingTop: 4, paddingBottom: 20,
                                flexDirection: "column", borderRadius: 10, backgroundColor: "#fff"}}>
                    <View style={{zIndex: 1, flexDirection: "row", alignItems: "center"}}>
                        <View style={{flex: 1}} />
                        <Button transparent onPress={this._toggleModal}>
                            <Icon name="ios-close" style={{ fontSize: 46, color:"#999999", marginRight: 0 }}/>
                        </Button>
                    </View>
                    <View style={{flexDirection: "column", alignItems: "center", marginTop: -30}}>
                        <Text style={{fontSize: 18, fontWeight: "bold"}}>{this.props.t("immediateWithdrawal")}</Text>
                    </View>
                    <View style={{flexDirection: "column", alignItems: "center", marginTop: 20}}>
                        <Text style={{fontSize: 16, fontWeight: "800"}}>{this.props.t("userEmail", { userEmail: this.props.user.email })}</Text>
                    </View>
                    {showCodeFailureMsg &&
                        <View style={{flexDirection: "column", alignItems: "center", marginTop: 5}}>
                            <Text style={{fontSize: 15, color: "red"}}>{this.props.t("showCodeFailureMsg")}</Text>
                        </View>}
                    <View style={{flexDirection: "row", alignItems: "center", marginTop: 20}}>
                        <TextInput
                            style={{flex: 1, borderWidth: 1, borderRadius: 5, fontSize: 30, borderColor: "#f7fafc", paddingVertical: 1, paddingHorizontal: 10, height: 40, borderRightWidth: 0, borderTopRightRadius: 0, borderBottomRightRadius: 0}}
                            onChangeText={(text) => this.props.setState({ verificationCode: text})}
                            value={verificationCode}
                            maxLength={6}
                            letterSpacing={8}
                            textAlignVertical="center"
                        />
                        <Button disabled={countDownStarted} style={{width: "45%", height: 40, backgroundColor: "#f7fafc",
                                        borderTopLeftRadius:0, borderBottomLeftRadius:0, borderRadius: 5, alignItems: "center", justifyContent: "center"}}
                                transparent onPress={this.props.sendVerifyCodeAsync}>
                            {countDownStarted ?
                                <Text style={{color: "#A9A9A9"}}>{this.props.t("countDown", { countDown })}</Text> :
                                <Text style={{color: "#2196f3"}}>{this.props.t("getCode")}</Text>}
                        </Button>
                    </View>
                    <View style={{flexDirection: "row", justifyContent: "space-around", marginTop: 40}}>
                       <Button style={{width: "30%", height: 30, backgroundColor: "#999999",
                                        borderRadius: 4, alignItems: "center", justifyContent: "center",  alignSelf:"flex-start"}}
                                transparent onPress={this._toggleModal}>
                            <Text style={{color: "#fff"}}>{this.props.t("cancel")}</Text>
                        </Button>
                        <Button style={{width: "30%", height: 30, backgroundColor: "#11cdef",
                                        borderRadius: 4, alignItems: "center", justifyContent: "center", alignSelf:"flex-end",}}
                                transparent onPress={() => {
                                    if (verificationCode?.length !== 6){
                                        this.props.setState({showCodeFailureMsg: true});
                                    } else {
                                        this.props.setState({showCodeFailureMsg: false});
                                        this.props.verifyCodeAsync({verificationCode});
                                    }
                                }}>
                            <Text style={{color: "#fff"}}>{this.props.t("determine")}</Text>
                        </Button>
                    </View>
                </View>);
    }

    _handleImmediateWithDrawal = () => {
        const {bankAccounts, bankAccountId, amountApplied, availableBalance, countDownStarted} = this.props.localState;
        if (!bankAccounts?.length)
            return this.displayError({message: this.props.t("noBankAccounts")});
        if (!bankAccountId)
            return this.displayError({message: this.props.t("noSelectBankAccounts")});

        let text = amountApplied;
        if (Number(text) > availableBalance) {
            return this.displayError({message: this.props.t("InsufficientFunds")});
        }

        if (!countDownStarted){
            this.props.sendVerifyCodeAsync();
        }
        this._toggleModal();
    };

    _toggleModal = () => {
        const { isOpen } = this.props.localState;
        this.props.setState({ isOpen: !isOpen , showCodeFailureMsg: false, verificationCode: null, countDown: null });
    };

    _handleChangeAmount = (text) => {
        this.props.setState({amountApplied: text});
    };

    _handleChangeAmountEnd = (e) => {
        let text = e.nativeEvent.text;
        text = text.replace(/[^\d.]/g,"");//清除"数字"和"."以外的字符
        text = text.replace(/^\./g,"");//验证第一个字符是数字而不是字符
        text = text.replace(/\.{2,}/g,".");//只保留第一个.清除多余的
        text = text.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
        text = text.replace(/^(\-)*(\d+)\.(\d\d).*$/,"$1$2.$3");//只能输入两个小数

        const { availableBalance } = this.props.localState;
        if (Number(text) > availableBalance) {
            text = availableBalance;
        }

        this.props.setState({ amountApplied: (text ? Number(text) : null) });
    };

    _handleCountDown = times => {
        if(!times || isNaN(parseInt(times))) {
            this.props.setState({ countDownStarted: false });
            return;
        }

        this.props.setState({ countDown: times });
        t = setTimeout(() => this._handleCountDown(--times), 1000);
    };

    _handleSendVerifyCodeAsyncDone = () => {
        this._handleCountDown(60);
    };

    _handlVerifyCodeAsyncDone = () => {
        const { baseCurrency, amountApplied, bankAccountId } = this.props.localState;
        this.props.saveWithdrawalAsync({ transactionType: 0, transactionData: JSON.stringify({ currencyCode: baseCurrency.code, amountApplied, bankAccountId }) });
    };

    _handleVerifyCodeAsyncActionError = () => {
        this.props.setState({ showCodeFailureMsg: true });
    };

    _handlSaveWithdrawalAsyncDone = () => {
        NavigationService.navigateToPage(this, UIDs.screens.me.myWallet);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };

    _onPressBack = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };
};

const styles = StyleSheet.create({
    centerAlign: {
        justifyContent: "center",
        alignItems: "center"
    },

    backgroundColor: {
        backgroundColor:"#f7f7f7"
    },

    headerColor: {
        backgroundColor:"#fff"
    },

    headerTitle: {
        color:"#111"
    },

    flex1: {
        flex:1
    },

    flex3: {
        flex:3
    },

    alignItemsCenter: {
        alignItems:"center"
    },

    backIcon: {
      fontSize:13,
      color:"#a5a5a5"
    },
});

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        user: state.session.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: () => dispatch(Actions.loadScreenViewAsync()),
        verifyCodeAsync: vo => dispatch(Actions.verifyCodeAsync(vo)),
        sendVerifyCodeAsync: () => dispatch(Actions.sendVerifyCodeAsync()),
        saveWithdrawalAsync: vo => dispatch(Actions.saveWithdrawalAsync(vo)),
        setState: (vo) => dispatch(Actions.setState(vo))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(WithdrawScreen));
